<template>
  <h2 class="text-center">
    <b-icon :icon="icon" class="mr-2"></b-icon><slot></slot>
  </h2>
</template>

<script>
export default {
  name: "Header",
  props: {
    icon: String
  }
};
</script>
